import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navigation({ siteData }) {
  const location = useLocation();
  const logo = siteData?.siteSettings?.logo;

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className='headernav'>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 16px' }}>
        <div className='row'>
          <div className='mainlogo col-2'>
          {/* Logo */}
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            {logo ? (
              <img 
                src={logo}
                alt="Toyota Logo" 
                style={{ 
                  height: '53px', 
                  width: 'auto',
                  maxWidth: '150px'
                }} 
              />
            ) : (
              <img 
                src="/images/logo.svg"
                alt="ALJ Türkiye Logo" 
                style={{ 
                  height: '53px', 
                  width: 'auto',
                  maxWidth: '150px'
                }} 
              />
            )}
          </Link>
          </div>

          {/* Desktop Menu */}
          <div className='headerlogosArea col-10 text-end'>
            <div className='headerrighttext'>ALJ TÜRKİYE</div>
          </div>
      
        </div>
        

      
      </div>
    </nav>
  );
}

export default Navigation;
